import { Grid, TextField } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import { ITextField } from "../components/signup/data/signup-fields";

const CenteredGrid = styled(Grid)`
  margin-left: 30px;
  margin-right: 30px;
`;

const TextInput = styled(TextField)`
  width: 100%;
  margin: 3px;
`;

interface IGetTextFieldsProps {
  fields: ITextField[];
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  getFieldValue: (id: string) => {};
}

function GetTextFields(props: IGetTextFieldsProps): JSX.Element[] {
  const { fields, onChange, getFieldValue } = props;

  return fields.map(field => {
    return (
      <CenteredGrid item lg={12}>
        {field.isTextArea ? (
          <TextInput
            key={field.id}
            id={field.id}
            label={field.label}
            placeholder={field.placeholder}
            InputLabelProps={field.placeholder ? { shrink: true } : undefined}
            variant="outlined"
            required={field.isRequired}
            size="small"
            multiline={true}
            rows={5}
            rowsMax={100}
            onChange={onChange}
            value={getFieldValue(field.id)}
          />
        ) : (
          <TextInput
            key={field.id}
            id={field.id}
            label={field.label}
            placeholder={field.placeholder}
            InputLabelProps={field.placeholder ? { shrink: true } : undefined}
            variant="outlined"
            required={field.isRequired}
            size="small"
            onChange={onChange}
            value={getFieldValue(field.id)}
          />
        )}
      </CenteredGrid>
    );
  });
}

export default GetTextFields;
